export default (err, vm, info) => {
  console.error(err);
  console.table([{ name: 'vm', data: vm }, { name: 'info', data: info }]);
  return false;
};
